import {initJumpmarks} from "./jumpmark";
import {focusInputGroups} from "./checkInputGroups";
import {hideMobileMenu, showMobileMenu} from "./mobileMenu";
import {setSrcVideos} from "./video";
import {testimonials} from "./testimonials";
import {accordion} from "./accordion";
import {clickFormItem} from "./clickFormItem";
import {initDatepickers} from "./datepicker";
import AOS from 'aos';
import {scrollingBanner} from "./scrollingBanner";

function stickyHeader(header){
    if(window.scrollY > header.clientHeight){
        header.classList.add("sticky");
    }else{
        header.classList.remove("sticky");
    }
}

window.onload = function (){
    const header = document.getElementById("header");
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");

    if (mobileMenu && mobileMenuToggle && overlay) {
        const mobileMenuClose = mobileMenu.querySelector(".mobileMenu__close");

        mobileMenuToggle.addEventListener("click", function () {
            if(mobileMenu.classList.contains("open")){
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            }else{
                showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            }
        });

        if(mobileMenuClose){
            mobileMenuClose.addEventListener("click", function () {
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            });
        }

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });


        for(let link of mobileMenu.querySelectorAll('.menu a')){
            link.addEventListener("click",function (){
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            });
        }
    }

    if(!document.body.classList.contains("body_home")){
        for(let link of document.querySelectorAll('#navigation a')){
            link.addEventListener("click",function (){
                location.href = "/"+link.getAttribute("href");
            });
        }
    }

    stickyHeader(header);
    window.addEventListener("scroll", function (e) {
        stickyHeader(header);
    });
    initJumpmarks(0);

    for(let wpcfCheckbox of document.querySelectorAll(".wpcf7-list-item")){
        wpcfCheckbox.addEventListener("click",function (){
            if(wpcfCheckbox.classList.contains("active")){
                wpcfCheckbox.classList.remove("active");
                wpcfCheckbox.querySelector("input").checked = false;
            }else{
                wpcfCheckbox.classList.add("active");
                wpcfCheckbox.querySelector("input").checked = true;
            }
        });
    }

    focusInputGroups();

    setSrcVideos();

    testimonials();

    accordion();

    clickFormItem();

    initDatepickers();

    AOS.init();

    scrollingBanner();

    /*for (let pinBox of document.querySelectorAll(".parallaxVideoBanner__content,.parallaxVideoBanner__image")) {
        stickyBox(pinBox, {
            offsetTop: 0,
            selectorPinArea: ".parallaxVideoBanner"
        });
    }*/

    checkSections();
    window.addEventListener("scroll", checkSections);
    window.addEventListener("resize", checkSections);
    window.addEventListener("orientationchange", checkSections);

    if(!document.body.classList.contains("body_home")){
        for(let link of document.querySelectorAll('.headerNavigation a,#mobileMenu a')){
            link.addEventListener("click",function (){
                location.href = "/"+link.getAttribute("href");
            });
        }
    }
}

function checkSections(){
    const mainWrapper = document.getElementById("mainwrapper");
    const header = document.getElementById("header");

    if(mainWrapper && header){
        let isDark = false;
        for(let section of mainWrapper.children){
            let sectionRect = section.getBoundingClientRect();
            section.classList.remove("is-active");
            if(sectionRect.top <= 0 && sectionRect.height + sectionRect.top > 0){
                section.classList.add("is-active");
                if(section.classList.contains("bg--black")){
                    isDark = true;
                }
            }
        }

        if(mainWrapper.classList.contains("bg--black")){
            isDark = true;
        }

        if(isDark){
            header.classList.remove("is-dark");
        }else{
            header.classList.add("is-dark");
        }
    }
}